import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import authApi from '../../api/authApi';
import { useToast } from '../../contexts/ToastContext';
import { useAuth } from '../../contexts/AuthContext';

const EmailVerificationPage = () => {
  const [loading, setLoading] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [generalError, setGeneralError] = useState(null);
  const { addToast } = useToast();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleResendVerification = async () => {
    setLoading(true);
    setGeneralError(null);
    setResendSuccess(false);

    try {
      const response = await authApi.resendVerificationEmail();
      if (response.success) {
        setResendSuccess(true);
        addToast('Verification email sent! Please check your inbox!', 'success');
      } else {
        setGeneralError(response.message || 'Failed to resend verification email.');
        addToast(response.message || 'Failed to resend verification email.', 'error');
      }
    } catch (err) {
      console.error('Resend verification error:', err);
      setGeneralError(err.response?.data?.message || 'An unexpected error occurred while resending the email.');
      addToast(err.response?.data?.message || 'Failed to resend verification email.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg w-full max-w-md text-center text-text-white">
        <h2 className="text-3xl font-bold mb-4">Verify Your Email Address</h2>
        <p className="mb-6">
          A fresh verification link has been sent to your email address.
          Please check your inbox (and spam folder) for the verification link.
        </p>
        {user && user.email && (
          <p className="mb-6 text-text-gray">
            If you did not receive the email, or would like to change your email, please contact support.
            Your current email: <span className="font-semibold text-white">{user.email}</span>
          </p>
        )}
        {generalError && (
          <div className="bg-red-600 text-white p-3 rounded mb-4">
            {generalError}
          </div>
        )}
        {resendSuccess && (
          <div className="bg-green-600 text-white p-3 rounded mb-4">
            Verification email sent successfully!
          </div>
        )}
        <Button
          onClick={handleResendVerification}
          className="w-full bg-accent-red hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mb-4"
          loading={loading}
        >
          Resend Verification Email
        </Button>
        <Button
          onClick={handleLogout}
          className="w-full bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          disabled={loading}
        >
          Logout
        </Button>
      </div>
    </div>
  );
};

export default EmailVerificationPage;